<ng-container *transloco="let t">
  <lib-change-password-form
    (onFormChange)="updatePassword($event)"
    (onCancel)="closeRef()"
    [loading]="submitLoading()"
    [error]="error()"
  />
</ng-container>
